import { css } from 'styled-components';
import {
  getSpacing,
  ThemedFunctor,
  SpacingName,
  BreakpointQueryName,
} from '@doveit/lego';

export const heroForm: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALLER, SpacingName.SMALLER, SpacingName.SMALLEST, SpacingName.SMALLER])}
  background: ${theme.palettes.neutrals.lightest};
  border: 1px solid ${theme.palettes.neutrals.light};
  border-radius: 6px;
  box-shadow: -1.25rem 1.25rem 1.25rem rgba(0,0,0,0.05);
  max-width: 40rem;
  margin: 0 auto;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    min-width: 30rem;
  }
`;
